// extracted by mini-css-extract-plugin
export default {"main":"Contact_main__woL9h","resume":"Contact_resume__7WPrU","sections":"Contact_sections__EtUuH","touch":"Contact_touch__2mxls","Contact":"Contact_Contact__s0MRk"};